import { http } from "../../core/utils/http";
import authHeader from "../../core/utils/auth.header.js";
import axios, { Axios } from "axios";
import {
  Create,
  RegisterAdminPayload,
  Update,
  UpdateAdminPayload,
} from "./interface/user.interface";
import authhHeader from "../../core/utils/authh.header";

class UserService {

  private readonly userBaseURL = import.meta.env.VITE_BASEURL;
  private readonly secondBaseURL = import.meta.env.VITE_SECOND_BASE_URL;

  constructor(private readonly request: Axios) {}
  
  private createAxiosInstance() {
    return axios.create({
      baseURL: this.userBaseURL,
      headers: authhHeader(), 
    });
  }
  private createSecondAxiosInstance() {
    return axios.create({
      baseURL: this.secondBaseURL,
      headers: authhHeader(),
    });
  }
  
  async show(userId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get(`/User/user-details/${userId}`, {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response || err;
      });
  }
  // async getUsers(): Promise<any> {
  //   return await this.request
  //     .get("/users", {
  //       headers: authHeader(),
  //     })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }
  async getUsers(organisationId: number, pageSize: number, pageNumber: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get("/Role/retrieve-managers", {
        params: {
          OrganisationId: organisationId,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getAdminUsers(
    organisationId: number | undefined,
    pageSize: number,
    pageNumber: number
  ): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("list request:", {
      OrganisationId: organisationId,
      PageSize: pageSize,
      PageNumber: pageNumber,
    });

    return await customRequest
      .get("/Admin/list", {
        params: {
          OrganisationId: organisationId,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
        headers: authhHeader(),
      })
      .then((res) => {
        console.log("list response:", res?.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "list error:",
          err?.response?.data || err
        );
        return err;
      });
  }

  async registerAdmin(payload: RegisterAdminPayload): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("Register request:", payload);

    return await customRequest
      .post("/Admin/Register", payload, {
        headers: {
          ...authhHeader(),
          "Content-Type": "application/json-patch+json",
        },
      })
      .then((res) => {
        console.log("Register response:", res?.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "Register error:",
          err?.response?.data || err
        );
        return err;
      });
  }

  async fetchAdmin(userId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("fetch/{id} request:", {
      id: userId,
    });

    return await customRequest
      .get(`/Admin/fetch/${userId}`, {
        headers: authhHeader(),
      })
      .then((res) => {
        console.log("fetch/{id} response:", res?.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "fetch/{id} error:",
          err?.response?.data || err
        );
        return err;
      });
  }

  async updateAdmin(payload: UpdateAdminPayload): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("update request:", payload);

    return await customRequest
      .put("/Admin/update", payload, {
        headers: {
          ...authhHeader(),
          "Content-Type": "application/json-patch+json",
        },
      })
      .then((res) => {
        console.log("update response:", res?.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "update error:",
          err?.response?.data || err
        );
        return err;
      });
  }

  async getNotifications(userId: number, pageSize: number, pageNumber: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get("/Notification/retrieve-notification", {
        params: {
          UserId: userId,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

 async markNotificationAsRead(notificationId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
    .put(`/Notification/mark-notification-asRead/${notificationId}`, {}, {
      headers: authhHeader(),
    })
    .then((res) => res)
    .catch((err) => err);
}

async getUnreadCount(): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
    .get("/Notification/unread-count", {
      headers: authhHeader(),
    })
    .then((res) => res)
    .catch((err) => err);
}

async deleteNotification(id: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
    .delete(`/Notification/${id}`, {
      headers: authhHeader(),
    })
    .then((res) => res)
    .catch((err) => err);
}

async deleteAllNotifications(): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
    .delete("/Notification/all", {
      headers: authhHeader(),
    })
    .then((res) => res)
    .catch((err) => err);
}
  
  async getUserRoleById(userId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
        .get(`/Role/get-user-role/${userId}`, {
            headers: authhHeader(),
        })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return err;
        });
      }
  async fetchRoles(): Promise<any> {
    const customRequest = this.createAxiosInstance();
    console.log("fetch-all request");

    return await customRequest
      .get("/Role/fetch-all", {
        headers: authhHeader(),
      })
      .then((res) => {
        console.log("fetch-all response:", res?.data);
        return res;
      })
      .catch((err) => {
        console.error(
          "fetch-all error:",
          err?.response?.data || err
        );
        return err;
      });
  }  

  async assignRole(requestBody: { userId: number; roleId: number }): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .post("/Role/assign-role", requestBody, {
        headers: authhHeader(),
      })
      .then((res) => res)
      .catch((err) => {
        console.error("Error assigning role:", err);
        throw err; 
      });
  }

  async updateRole(userId: number, roleId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .put(`/Role/update/${userId}/${roleId}`, null, {
        headers: authhHeader(),
      })
      .then((res) => res)
      .catch((err) => {
        console.error("Error assigning role:", err);
        throw err; 
      });
}

  async submitKycInfo(kycData: {
    organisationId: number;
    firstname: string;
    middlename?: string;
    lastname: string;
    phone: string;
    email: string;
    gender: string;
    country: string;
    address: string;
    bvn: string;
  }): Promise<any> {
    const customRequest = this.createSecondAxiosInstance();
    return await customRequest
      .post("/Kyc/submit-info", kycData, {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

//   async submitKycDocuments(documentData: {
//     organisation_id: number;
//     files: File[];
//   }): Promise<any> {
//     const customRequest = this.createSecondAxiosInstance();
//     const formData = new FormData();
    
//     formData.append('OrganisationId', documentData.organisation_id.toString());
    
//     // Debugging: Log file metadata before appending
//     console.log("Files to upload:", documentData.files.map(f => ({
//       name: f.name, 
//       size: f.size, 
//       type: f.type
//     })));
  
//     documentData.files.forEach((file) => {
//       formData.append('Files', file);
//     });
  
//     console.log("FormData entries:");
// formData.forEach((value, key) => {
//   if (value instanceof File) {
//     console.log(`${key}: File name=${value.name}, size=${value.size}`);
//   } else {
//     console.log(`${key}: ${value}`);
//   }
// });
//     return await customRequest
//       .post("/Kyc/submit-document", formData, {
//         headers: { ...authhHeader() },
//       })
//       .then((res) => res)
//       .catch((err) => {
//         console.error("Full error response:", err.response?.data);
//         return err;
//       });
//   }

async submitKycDocuments(documentData: {
  organisation_id: number;
  files: { file: File; documentType: string }[];
}): Promise<any> {
  const customRequest = this.createSecondAxiosInstance();
  const formData = new FormData();

  formData.append('OrganisationId', documentData.organisation_id.toString());

  // Append each file with its document type and file
  documentData.files.forEach((item, index) => {
    formData.append(`Files[${index}].DocumentTypes`, item.documentType);
    formData.append(`Files[${index}].DocumentUrl`, item.file);
  });

  console.log("FormData entries:");
  formData.forEach((value, key) => {
    if (value instanceof File) {
      console.log(`${key}: File name=${value.name}, size=${value.size}`);
    } else {
      console.log(`${key}: ${value}`);
    }
  });

  return await customRequest
    .post("/Kyc/submit-document", formData, {
      headers: { ...authhHeader() },
    })
    .then((res) => res)
    .catch((err) => {
      console.error("Full error response:", err.response?.data);
      return err;
    });
}

async getKycDocuments(organisationId: number): Promise<any> {
  const customRequest = this.createSecondAxiosInstance();

  return await customRequest
    .get(`/Kyc/documents${organisationId}`, {
      headers: { ...authhHeader() },
    })
    .then(res => res)
    .catch(err => {
      console.error("Error fetching KYC documents:", err.response?.data);
      return err;
    });
}

async getKycStatus(organisationId: number): Promise<any> {
  const customRequest = this.createSecondAxiosInstance();

  return await customRequest
    .get(`/Kyc/${organisationId}`, {
      headers: { ...authhHeader() },
    })
    .then(res => res)
    .catch(err => {
      console.error("Error fetching KYC status:", err.response?.data);
      return err;
    });
}

// async getKycStatus(organisationId: number): Promise<any> {
//   const customRequest = this.createSecondAxiosInstance();
  
//   return await customRequest
//     .get(`/Kyc/${organisationId}`, {
//       headers: { ...authhHeader() },
//     })
//     .then(res => res)
//     .catch(err => {
//       console.error("Error fetching KYC status:", err.response?.data);
//       return err;
//     });
// }


  // async submitKycDocuments(payload: { organisationId: number; files: File[] }): Promise<any> {
  //   const formData = new FormData();
  //   formData.append("OrganisationId", payload.organisationId.toString());
  
  //   // Append each file to the form data with key "Files"
  //   payload.files.forEach(file => {
  //     formData.append("Files", file);
  //   });
  
  //   const customRequest = this.createSecondAxiosInstance();
  
  //   return await customRequest
  //     .post("/Kyc/submit-document", formData, {
  //       headers: {
  //         ...authhHeader(),
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then(res => res)
  //     .catch(err => err);
  // }
  

async deleteUser(userId: string): Promise<any> {
  const customRequest = this.createAxiosInstance();
  return await customRequest
    .delete(`/Role/remove-user/${userId}`, {
      headers: authhHeader(),
    })
    .then((res) => res)
    .catch((err) => {
      console.error("Error removing user:", err);
      throw err; 
    });
}

  async create(data: Create): Promise<any> {
    return await this.request
      .post(
        "/users",
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async verify(verify: string): Promise<any> {
    return await this.request
      .post(`/verify/${verify}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async update(data: Update, id: string): Promise<any> {
    return await this.request
      .put(
        `/users/${id}`,
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async delete(id: string): Promise<any> {
    return await this.request
      .delete(
        `/users/${id}`,

        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async updateUserImage(userId: number, formData: FormData): Promise<any> {
  const customRequest = this.createAxiosInstance();

  formData.append('UserId', userId.toString());

  return await customRequest
    .put(`/User/update-user-image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...authhHeader(),
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error("Error fetching KYC status:", err.response);
      return Promise.reject(err);
    });
}



}

export default new UserService(http);
